import type { StationBoardListItem } from '@/utils/helpers/get-station-board-list-items';

function getStationBoardItem(items: StationBoardListItem[], isArrivalList?: boolean) {
  return items.reduce(
    (acc, item) => {
      const { state, arrival, departure } = item.journey ?? {};

      const timeString = isArrivalList ? arrival : departure;
      const scheduledTimestampMs = timeString ? new Date(timeString).getTime() : 0;

      const isCancelled = state === 'Cancelled';
      const isExpected = state === 'Expected';
      const isUpcomingCancellation = isCancelled && scheduledTimestampMs >= Date.now();
      const isItemNext =
        isUpcomingCancellation || isExpected || (!isArrivalList && state === 'Arrived');

      if (isItemNext) {
        acc.nextItems.push(item);
      } else {
        acc.previousItems.push(item);
      }

      return acc;
    },

    { previousItems: [] as StationBoardListItem[], nextItems: [] as StationBoardListItem[] }
  );
}

export default getStationBoardItem;
